import { combineEpics } from 'redux-observable';

import { findProcessStatementQuestionsEpic }    from './FindProcessStatementQuestions/FindProcessStatementQuestionsEpic';
import { persistProcessStatementQuestionsEpic } from './PersistProcessStatementQuestions/PersistProcessStatementQuestionsEpic';

export default combineEpics(
  findProcessStatementQuestionsEpic,
  persistProcessStatementQuestionsEpic,
);
